import { useGetCurrentSessionUser } from '../../hooks/useGetCurrentSessionUser';
import { currentSelectedClientType } from '../Client/useSwitchClientList';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

export function useGetUserRole() {
  const { user } = useSelector((state: RootState) => state.auth);
  const [userRole, setUserRole] = useState<
    'client' | 'subClient' | undefined
  >();
  const currentSelectedClient = useGetCurrentSessionUser(
    'currentSelectedClient'
  ) as currentSelectedClientType;

  useEffect(() => {
    if (!currentSelectedClient) {
      if (user?.isSuperAdminUser === false && user?.isLoginUsingClientUrl === true) {
        setUserRole('client');
      }

      if (user?.isSuperAdminUser === false && user?.isLoginUsingClientUrl === false) {
        setUserRole('subClient');
      }
    }

    if (currentSelectedClient) {
      if (currentSelectedClient?.isClient) {
        setUserRole('client');
      }

      if (!currentSelectedClient?.isClient) {
        setUserRole('subClient');
      }
    }
  }, [JSON.stringify(user)]);

  return { userRole };
}
